import { createContext, useContext } from 'react';
import { ManagementSettingsContextType } from 'modules/intelligentInsights/frequencyOptimization/types';
import { MessageMedium } from 'constants/messageMediums';
import { FrequencyMode } from 'modules/frequencyManagement/lib/types';

export const defaultContext: ManagementSettingsContextType = {
  frmManagementSettings: {
    [MessageMedium.Email]: {
      isConfiguredForSending: true,
      settings: {
        mode: FrequencyMode.Off,
        period: null,
        maxAllowed: null,
        minAllowed: null,
        frequencyOptimizationDetails: null,
        frequencyOptimizationDetailsUpdatedAt: null,
      },
      messageTypes: [],
    },
    [MessageMedium.SMS]: {
      isConfiguredForSending: true,
      settings: {
        mode: FrequencyMode.Off,
        period: null,
        maxAllowed: null,
        minAllowed: null,
        frequencyOptimizationDetails: null,
        frequencyOptimizationDetailsUpdatedAt: null,
      },
      messageTypes: [],
    },
    [MessageMedium.Push]: {
      isConfiguredForSending: true,
      settings: {
        mode: FrequencyMode.Off,
        period: null,
        maxAllowed: null,
        minAllowed: null,
        frequencyOptimizationDetails: null,
        frequencyOptimizationDetailsUpdatedAt: null,
      },
      messageTypes: [],
    },
  },
  isError: false,
  isLoading: false,
  isReady: true,
};

export const ManagementSettingsContext =
  createContext<ManagementSettingsContextType>(defaultContext);

export const useManagementSettingsContext = () => useContext(ManagementSettingsContext);
